function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Pressable } from 'react-native';
import styled from 'styled-components/native';
import { useHover, useActive } from 'react-native-web-hooks';
import Text from '../text';
import Colors from '../colors';
import Icon from '../icon';
import Spacer from '../spacer';
const colors = {
  normal: {
    text: Colors.gray500,
    link: Colors.purple400,
    hoverLink: Colors.purple500,
    activeLink: Colors.purple600,
    arrow: Colors.gray400,
    lastArrow: Colors.gray400
  },
  white: {
    text: Colors.white,
    link: Colors.purple200,
    hoverLink: Colors.purple300,
    activeLink: Colors.purple400,
    arrow: Colors.lightGray500,
    lastArrow: Colors.white
  }
};
const StyledContainer = styled.View`
  flex-direction: row;
  justify-content: flex-start;
`;

const StyledLink = link => {
  const ref = useRef();
  const isHovered = useHover(ref);
  const isActive = useActive(ref);
  const styles = {
    hovered: {
      color: colors[link.type].hoverLink
    },
    active: {
      color: colors[link.type].activeLink
    }
  };
  return /*#__PURE__*/React.createElement(Pressable, {
    ref: ref,
    onPress: link.onPress
  }, /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    style: [isHovered && styles.hovered, isActive && styles.active],
    weight: "medium",
    color: colors[link.type].link
  }, link.label));
};

const isLastLink = (array, link) => array.length === array.indexOf(link) + 1;

export default function Breadcrumb(props) {
  const colorType = Object.keys(colors).includes(props.color) ? props.color : Breadcrumb.defaultProps.color;
  return /*#__PURE__*/React.createElement(StyledContainer, null, props.links.map(link => /*#__PURE__*/React.createElement(StyledContainer, {
    key: link.label
  }, /*#__PURE__*/React.createElement(StyledLink, _extends({
    type: colorType
  }, link)), /*#__PURE__*/React.createElement(Spacer, {
    size: "f2",
    width: true
  }), /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: "chevron-right",
    size: 13,
    color: isLastLink(props.links, link) ? colors[colorType].lastArrow : colors[colorType].arrow
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f2",
    width: true
  }))), /*#__PURE__*/React.createElement(Spacer, {
    size: "f2",
    width: true
  }), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    weight: "regular",
    color: colors[colorType].text
  }, props.children));
}
Breadcrumb.defaultProps = {
  color: 'normal',
  links: [{
    label: 'Link',
    onPress: () => {}
  }],
  children: ''
};
Breadcrumb.propTypes = {
  color: PropTypes.oneOf(Object.keys(colors)),
  links: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    onPress: PropTypes.func
  })),
  children: PropTypes.node
};
//# sourceMappingURL=index.js.map